"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QC_NAMES = exports.QcLookup = void 0;
var QcLookup;
(function (QcLookup) {
    QcLookup["Inmar"] = "Inmar";
    QcLookup["Deliverr"] = "Deliverr";
    QcLookup["Optoro"] = "Optoro";
    QcLookup["Self"] = "Self";
})(QcLookup || (exports.QcLookup = QcLookup = {}));
exports.QC_NAMES = ["Deliverr" /* QcLookup.Deliverr */, "Inmar" /* QcLookup.Inmar */, "Optoro" /* QcLookup.Optoro */];
//# sourceMappingURL=QcLookup.js.map